yogaShiftContainer.$inject = ["API_URL", "$rootScope", "$location", "SingleSlotService"];
angular.module('directive.yogaShiftContainer', []).directive('yogaShiftContainer', yogaShiftContainer);

function yogaShiftContainer(API_URL, $rootScope, $location, SingleSlotService) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/yoga-shift-container.html',
    scope: {
      shift: '='
    },
    link: function link(scope, elem, attrs) {
      scope.timeSettings = $rootScope.timeSettings;
      scope.shift.start = scope.shift.timeslots[0].start;
      scope.shift.end = scope.shift.timeslots[scope.shift.timeslots.length - 1].end + 1;
      scope.shift.timeslotsLength = scope.shift.timeslots.length;
      scope.shift.serviceName = scope.shift.service.name;
      scope.shift.resourceName = scope.shift.resource && scope.shift.resource.name;
      scope.waitlist = scope.shift.canwaitlist;

      function init() {
        // Figure out if there is any availability in this shift
        scope.shiftAvailable = false;

        for (var i = 0; i < scope.shift.timeslots.length; i++) {
          var timeslot = scope.shift.timeslots[i];

          if (timeslot.available > 0) {
            scope.shiftAvailable = true;
            break;
          }
        }
      }

      init();

      scope.chooseShift = function (shift) {
        var waitlist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        $rootScope.chosenShift = shift;
        $rootScope.chosenShift.waitlist = waitlist; // Record this here so it can be picked up on the login / register page
        // Must be authenticated to continue

        if (!$rootScope.customerInfo) {
          $location.path('/login');
          return;
        } // If the shift is full and there is a waitlist, take them to the choose slots
        // page automatically where they can choose the waitlist.


        if (waitlist) {
          return $location.path('/chooseslots');
        } // Don't show the slot chooser if there's only one slot.
        // But show the choose slots page if the user can book the timeslot
        // more than once.
        // - Also the only way the user can add themselves to the waitlist is on
        // the choose slots page so redirect automatically if this shift is full


        if (shift.timeslots.length > 1 || shift.bookmulti > 1) {
          return $location.path('/chooseslots');
        }

        SingleSlotService.reserveSlot(shift).then(function () {
          // No slot chooser, show future days?
          if (smooth.calendarSettings.bookfuturedays) {
            $location.path('/futureslots');
            return;
          }

          $location.path('/review');
        });
      };
    }
  };
}